import { render } from "./assignRole.vue?vue&type=template&id=cc4230d4"
import script from "./assignRole.vue?vue&type=script&lang=js"
export * from "./assignRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__